import React, { ReactNode } from 'react';
import { Box, Grid } from '@mui/material';
import { CarModel } from 'models/StockModel';
import { AuthModel } from 'models/AuthModel';
import CarMenu from 'modules/cars/common/CarMenu';
import DocPreview from 'modules/cars/common/DocPreview';
import CarCardStatic from 'modules/cars/common/CarCardStatic';
import CarCard from 'modules/cars/cards/CarCard';
import PartiesCard from 'modules/cars/cards/PartiesCard';
import InnerCargoCard from 'modules/cars/cards/InnerCargoCard';
import NotesCard from 'modules/cars/cards/NotesCard';
import StatusButtonsCard from 'modules/cars/cards/StatusButtonsCard';
import CompanyCard from 'modules/cars/cards/CompanyCard';
import InvoiceCard from 'modules/cars/cards/InvoiceCard';
import YardCard from 'modules/cars/cards/YardCard';
import ShippingCard from 'modules/cars/cards/ShippingCard';
import ExportCertCard from 'modules/cars/cards/ExportCertCard';
import DocumentsCard from 'modules/cars/cards/DocumentsCard';
import PhotoCard from 'modules/cars/cards/PhotoCard';
import DestinationYardCard from 'modules/cars/cards/DestinationYardCard';
import { exportCertificateRequired } from 'modules/cars/utils/common';


type CarViewProps = {
    current: number,
    car: CarModel,
    my: AuthModel,
    title: ReactNode,
    canEdit: boolean,
    docPreview?: string|null
}

const CarDesktop = ({car, my, canEdit, title, docPreview, current}: CarViewProps) => {
    return (
        <Grid container spacing={2}>
            {!docPreview && (
                <Grid item sm={3}>
                    <CarMenu current={current}/>
                </Grid>
            )}

            <Grid item xs={12} sm={docPreview ? 12 : 9}>
                <Box sx={{height: {md: 'calc(100vh - 48px)'}, overflow: 'auto', pr: 2, pt: 2}}>
                    <Grid container spacing={2}>
                        <Grid item xs={docPreview ? 4 : 8}>
                            {my.permissions.has('cars update') && canEdit ?
                                <CarCard key={`${car.id}${car.updatedAt}`} title={title} car={car}/> :
                                <CarCardStatic title={title} car={car}/>
                            }

                            <PartiesCard partyableType="car" partyable={car}/>

                            <InnerCargoCard car={car}/>

                            <NotesCard car={car}/>
                        </Grid>

                        {docPreview && (
                            <Grid item xs={6}>
                                <DocPreview
                                    type={docPreview}
                                    carId={car.id}
                                />
                            </Grid>
                        )}

                        <Grid item xs={docPreview ? 2 : 4}>
                            <StatusButtonsCard car={car}/>

                            <CompanyCard car={car}/>

                            <InvoiceCard car={car}/>

                            <YardCard car={car}/>

                            <ShippingCard car={car}/>

                            {exportCertificateRequired(car) && <ExportCertCard car={car}/>}

                            <DocumentsCard car={car}/>

                            <PhotoCard car={car}/>

                            <DestinationYardCard car={car}/>

                            <Box height="64px"/>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    );
};

export default CarDesktop;
